import NarrowSecureLayout from "../../layout/NarrowSecureLayout.jsx";
import {useTranslation} from "react-i18next";
import {useEffect, useMemo, useState} from "react";
import Button from "../../components/Button.jsx";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRefresh} from "@fortawesome/free-solid-svg-icons/faRefresh";
import LoadingComponent from "../../components/LoadingComponent.jsx";
import {SystemApi} from "../../api/authority/generated/index";
import useAuthorityConfiguration from "../../api/utilities/useAuthorityConfiguration.js";
import IntegrationRow from "./IntegrationRow.jsx";
import SeeMore from "../../components/SeeMore.jsx";

export default function ServiceStatus() {
    let {t} = useTranslation();

    let [data, setData] = useState(null);

    let config = useAuthorityConfiguration();

    useEffect(() => {
        if (data !== null) {
            return;
        }

        new SystemApi(config)
            .applicationStatus()
            .then(setData);

    }, [data]);

    let toRow = (projectData, status) => {
        return {
            integrationId: status.integrationId,
            status: status.status,
            logoUrl: projectData.logoUrl,
            projectName: projectData.name,
            integrationName: status.integrationName,
            lastSuccessfulUpdate: status.lastSuccessfulUpdate,
            nextUpdate: status.nextUpdate,
            error: status.error,
        };
    };

    let filterRows = (data, requiredStatus) => {
        if (data === null) {
            return [];
        }

        let rows = [];

        for (let projectWithIntegration of data.projectsWithIntegrations) {
            for (let status of projectWithIntegration.integrationStatuses) {
                if (status.status === requiredStatus) {
                    rows.push(toRow(projectWithIntegration.projectData, status));
                }
            }
        }

        return rows;
    };

    let failedRows = useMemo(() => filterRows(data, 'Failed'), [data]);
    let scheduledRows = useMemo(() => filterRows(data, 'Scheduled'), [data]);
    let runningRows = useMemo(() => filterRows(data, 'Running'), [data]);
    let succeededRows = useMemo(() => filterRows(data, 'Succeeded'), [data]);

   // console.log({failedRows, scheduledRows, runningRows, succeededRows});

    return <NarrowSecureLayout
        title={t('route.service-status')}
        actions={
            <Button className={'button-success'}>
                <FontAwesomeIcon icon={faRefresh} onClick={() => setData(null)}/>
            </Button>
        }
    >
        <LoadingComponent loading={data === null}>
            {failedRows.length > 0 && <div className={'h4'}>{t('integration.status.error')}</div>}
            {failedRows.map((row) => <IntegrationRow row={row} key={row.integrationId}/>)}
            {runningRows.length > 0 && <div className={'h4'}>{t('integration.status.running')}</div>}
            {runningRows.map((row) => <IntegrationRow row={row} key={row.integrationId}/>)}
            <SeeMore active={data !== null} heightClass={'h-64'}>
                {scheduledRows.length > 0 && <div className={'h4'}>{t('integration.status.scheduled')}</div>}
                {scheduledRows.map((row) => <IntegrationRow row={row} key={row.integrationId}/>)}
                {succeededRows.length > 0 && <div className={'h4'}>{t('integration.status.finished')}</div>}
                {succeededRows.map((row) => <IntegrationRow row={row} key={row.integrationId}/>)}
            </SeeMore>
        </LoadingComponent>
    </NarrowSecureLayout>;
}